import script from "./BatchTab.vue?vue&type=script&setup=true&lang=ts"
export * from "./BatchTab.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__